<meta charset="utf-8">
<meta name="viewport" content="width=device-width, initial-scale=1">
<!-- ... end Preloader style="background-color: lightblue;" -->
<div class="content-bg-wrap landing-page "></div>

<div class="contai1ner">
    <div class="row">
        <div class="col-12">
<!-- Header Standard Landing  -->

<div class="header--stand1ard header--standard-landing pull-left" style="margin-left:0px; position: relative;" id="header--standard">
    <div class="contai1ner">
        <div class="header--standard-wrap">
            <a href="javascript:void(0);" class="logo">
                <div class="img-wrap mt-1">
                    <img class="img-fluid" src="../../../assets/../../../assets/img/logo.webp" alt="Football Families">

                </div>
                <div class="title-block">
                    <h6 class="logo-title" style="font-size: 1.6rem;"> Football Family </h6>
                </div>
            </a>

           
        </div>
    </div>
</div>
</div>
<div class="col-12 col-lg-12">
<!-- ... end Header Standard Landing  -->
<div class="contain1er">
    <div class="row display-flex" style="padding-top: 20px;">
        <div class="col col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
            <div class="landing-content"  style="padding: 20px;">
                <h3 style="font-weight:100;">Welcome to Football Family World</h3>
                <p style=" font-weight: 500; background-color: #ffffff81; padding: 10px; border-radius: 10px; ; display: none;">
                    <span style="color:#202020; font-size: 22px">Register with us and get your privileges:</span><br><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">1-</span>  Participate in the vote and win awards and cash with us.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">2-</span>  Your favorite player you voted him, will be the one who will give you awards.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">3-</span>  Preference for the fastest first 10 votes at the level of each country.</span><br>
                    <span style="color:#4b4b4b; font-size: 18px"><span style="color: #202020;">4-</span>  Communicate with your favorite player via video call ( <span style="color: #336699;"><i class="fad fa-video"></i>&nbsp;Communicator</span> ).</span><br>
                </p>
                <h3 style="font-weight:100;">Football Family have the advantage of being a comprehensive social media platform.</h3>
                <h3 style="font-weight:100;">A few steps then you join with us , Register Now!</h3>
            </div>
        </div>
        <div class="col col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
            <!-- <div *ngIf="errorFlag" class="alert alert-danger" role="alert">
                {{message}} <br> Please Login ! click <a routerLink="/login"> here </a>
            </div> -->
            <!-- Login-Registration Form  -->
            <div class="registration-login-form">
                <!-- Nav tabs -->
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item ">
                        <a class="nav-link" data-toggle="tab" routerLink="/login" role="tab" style="background-color: #336699;">
                            <i class="fad fa-user-lock" style="color:#fff;"></i>
                        </a>
                    </li>
                    <li class="nav-item ">
                        <a class="nav-link active" data-toggle="tab" routerLink="/register" role="tab" style="background-color: #202020;">
                            <i class="fad fa-user-plus" style="color:#fff;"></i>
                        </a>
                    </li>
                </ul>
                <!-- Tab panes -->
                <div class="tab-content">
                    <div class="tab-pane active " id="home" role="tabpanel" data-mh="log-tab">
                        <div class="title h3" style="background-color:#202020; color:#fff; font-weight: 600;">Register to Football Families</div>
                        <form [formGroup]="registerForm" (ngSubmit)="signUp()" class="content">
                            <!--  -->
                            <div *ngIf="show" class="row">
                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">First & Middle
                                            Name <span style="color: red;"> * </span> </label>
                                        <input placeholder="" name="First Name" formControlName="fullName" pattern="[a-zA-Z ]*" type="text" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.fullName.errors }" style="height: 60px;">
                                        <div *ngIf="submitted && f.fullName.errors" class="invalid-feedback">
                                            <div *ngIf="f.fullName.errors.required">First & middle Name is required
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Last Name <span
                                                style="color: red;"> * </span></label>
                                        <input placeholder="" name="First Name" formControlName="lastName" pattern="[a-zA-Z ]*" type="text" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" style="height: 60px;">
                                        <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback">
                                            <div *ngIf="f.lastName.errors.required">Last Name is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Gender <span style="color: red;"> * </span></label>
                                        <select formControlName="gender" name="gender" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.gender.errors }" style="height: 60px;">
                                            <option value="male" selected>Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                        <div *ngIf="submitted && f.gender.errors" class="invalid-feedback">
                                            <div *ngIf="f.gender.errors.required">Gender is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group label-floating">

                                        <div class="form-group label-floating">
                                            <label class="control-label custom-lable">Date Of birth <span style="color: red;"> *
                                                </span></label>

                                            <input placeholder="02/03/1990" bsDatepicker [minDate]="minDate" [maxDate]="maxDate" formControlName="dob" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dob.errors }" style="height: 60px;">

                                            <div *ngIf="submitted && f.dob.errors" class="invalid-feedback">
                                                <div *ngIf="f.dob.errors.required">Date of birth is required</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="form-group ">
                                        <!-- <label class="control-label" style="padding-right: 62px;padding-left: 100px;line-height: 2.0;">Mobile Number</label> -->
                                        <input style="padding-right: 70px;padding-left: 100px;line-height: 2.0; width: 100%; " placeholder="55 555 5555" ng2TelInput (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" formControlName="mobileNumber"
                                            class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobileNumber.errors }">
                                        <div *ngIf="submitted && f.mobileNumber.errors" class="invalid-feedback">
                                            <div *ngIf="f.mobileNumber.errors.required"> Mobile Number is required</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">

                                    <div class="form-group">
                                        <label class="control-label custom-lable">Nationality <span
                                                style="color: red;"> * </span></label>

                                        <ng-autocomplete style="font-weight: 700;" formControlName="countryName" placeHolder="Country Name" [data]="countryList" [searchKeyword]="keyword" (selected)='selectEvent($event)' [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" [ngClass]="{ 'is-invalid': submitted && f.countryName.errors }">
                                        </ng-autocomplete>

                                        <ng-template #itemTemplate let-country>
                                            <a [innerHTML]="country.name" ></a>
                                        </ng-template>

                                        <ng-template #notFoundTemplate let-notFound>
                                            <div [innerHTML]="notFound"></div>
                                        </ng-template>
                                    </div>
                                    <small class="form-text text-muted error" *ngIf="!registerForm.controls['countryName'].valid && !isSubmitted">
                                        country is required
                                    </small>
                                </div>
                                <!-- <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="form-group ">
                                        <label class="control-label" style="padding-right: 62px;padding-left: 100px;line-height: 2.0;">Mobile Number</label> 
                                        <input class="form-control" style="padding-right: 70px;padding-left: 100px;line-height: 2.0; width: 100%;" ng2TelInput (ng2TelOutput)="getNumber($event)" (intlTelInputObject)="telInputObject($event)" (countryChange)="onCountryChange($event)" formControlName="mobileNumber"
                                            placeholder="55 555 5555">
                                        <small class="form-text text-muted error" *ngIf="!registerForm.controls['mobileNumber'].valid && !isSubmitted">
                                            Mobile# is required: hints (9 numbers)
                                        </small>
                                    </div>
                                </div> -->
                                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable"> Email <span
                                                style="color: red;"> * </span></label>
                                        <input placeholder="Enter your Email" name="email" formControlName="email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$" type="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }">
                                        <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                            <div *ngIf="f.email.errors.required">Email is required</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Your Password
                                            <span style="color: red;"> * </span></label>
                                        <input class="form-control" name="password" placeholder="Enter Password" formControlName="password" type="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">Password is required
                                            </div>
                                        </div>
                                        <small class="form-text text-muted error" *ngIf="!registerForm.controls['password'].valid && !isSubmitted">
                                            Hints:(min 8 chars) required
                                        </small>
                                    </div>
                                </div>
                                <div class="col col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12">

                                    <div class="form-group label-floating">
                                        <label class="control-label custom-lable">Confirm Password
                                            <span style="color: red;"> * </span></label>
                                        <input class="form-control" name="password" placeholder="Confirm password" formControlName="confirmPassword" type="password" [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors }">
                                        <div *ngIf="submitted && f.confirmPassword.errors" class="invalid-feedback">
                                            <div *ngIf="f.confirmPassword.errors.required">confirmPassword is required Hints:(min 8 chars) </div>
                                            <div *ngIf="f.confirmPassword.errors.mustMatch">Passwords must match</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-12 col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                    <!-- (click)="signUp()" -->
                                    <button [disabled]="loading" class="btn btn-pri1mary full-wid1th" style="font-size: 18px; background-color: #202020;">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                        <i class="fad fa-user-plus"></i>&nbsp;Register
                                    </button>
                                    <div *ngIf="errorFlag" class="alert alert-danger" role="alert">
                                        {{message}} <br> For Login ! click <a routerLink="/login"> here </a>
                                    </div>
                                    <div class="remember">
                                        <p class="customStyle">You have an account? <a data-toggle="tab" routerLink="/login" role="tab">Login
                                                Now!</a></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- ... end Login-Registration Form  -->
        </div>
        
    </div>
</div></div></div></div>